module.exports = __webpack_public_path__ + "static/margie_zak-427aa7076e222677bd4147b90d1f7740.jpg";